import { FormattedMessage } from 'react-intl'
import LogoutButton from './logout-button'

const Logout = () => (
  <div>
    <div>
      <FormattedMessage id="registerform_logoutRequired" />:
      <LogoutButton>
        <FormattedMessage id="registerform_logout" />
      </LogoutButton>
    </div>
  </div>
)

export default Logout
